export default {
    'bond-number': 'Bond No.',
    new: 'New',
    'cash-statement': 'Cashbox Statement',
    add: 'Add',
    'posted-journals-balance': 'Posted journals balance',
    edit: 'Edit',
    'save-bond': 'Save bond',
    save: 'Save',
    bond: '',
    not: 'Non',
    posted: 'Posted',

    'delete-cash-entry': 'Delete cash entry',
    'are-you-sure-you-want-delete-the-entry' : 'Do you want to delete this row? The related composite accounting entry will also be deleted.',

    'add-bond': 'Add bond',
    'bond-date': 'Bond date',
    create: 'Create',
    cancel: 'Cancel',
    warning: 'Alert',
    'No-fund-has-been-set-for-the-financial-file-yet': 'Main Cash Box Account unassigned! Please go to settings to assign it',
    sum: 'Total:',
    'total-imports': 'Total income:',
    'total-exports': 'Total expense:',
    'difference': 'Difference:',

    'incoming-coins': 'Foreign currency income:',
    'outcome-coins': 'Foreign currency expense:',

    'currency-equivalent': 'Balance in another currency',
    'select-currency-to-show-the-currency-equivalent': 'Choose the currency to exchange',

    'make-sure-the-data-entered-is-correct': 'Verify the entered data',
    headers: {
        sequence: 'Serial',
        account: 'Account',
        debit: 'Expense',
        credit: 'Revenue',
        note: 'Description',
        currency: 'Currency',
        'currency-debit': 'Foreign currency income',
        'currency-credit': 'Foreign currency expense',
        price: 'Price',
        'paper-document-no': 'Ref. Doc.',
        'date': 'Date',
    },

    'not-posted-bonds': 'Non-posted bonds',
    'all-bonds-are-posted': 'All bonds are posted',

    'context-menu': {
        'account-statement' : 'Account statement',
        'edit' : 'Edit',
        'delete' : 'Delete'
    },

    'revolving-balance': 'Revolving balance:',

    footer: {
        total: 'Total',
        difference: 'Difference',
        revolved: 'Revolved'
    },
    "reverse-currency-price": "Reverse the direction of currency price calculation",
    "export-payment-bond": "Export payment bond",
    "export-repayment-bond": "Export repayment bond",

}